import { resetPluCallback, setPluCallback } from 'src/bottom-area/business-logic/handle-plu-items';
import { EmeraldError, EmeraldErrorModal } from 'src/common/api/emerald-error';
import { AbortedError } from 'src/common/api/extended-emerald-error';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { ISelectedItem } from 'src/common/interfaces/dtos/ISelectedItem';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { cancelItemByCode } from 'src/home-page/business-logic/cancel-line-or-item';
import { formatScannedData } from 'src/home-page/business-logic/submit-scanned-data';
import { popupMessage } from 'src/messages/business-logic/popup-message';
import { showTenderAmountEligibilityModal } from 'src/price-override/business-logic/handle-price-override';
import { showEwicErrorModal } from 'src/tendering/business-logic/handle-ewic-error-handling';
import { restorePage } from '../../common/components/emerald-home-page/emerald-home-page';
import { EmeraldDialogTypes } from '../../common/enumerations/emerald-dialog-types';
import * as errorCodes from '../../common/helpers/error-code';
import { WicTenderRestriction } from '../../common/helpers/error-code';
import { store } from '../../common/redux/configure-store';
import { showVoidByCodeWindow } from '../components/void-item-by-code';

export const handleVoidByCode = async (): Promise<void> => {
  return new Promise<void>((resolve, reject): void => {
    const formatError = (err: EmeraldError, itemId: string): EmeraldError => {
      if (
        err.code === errorCodes.ItemNotFound ||
        err.code === 'EmeraldItemNotFound' ||
        err.code === 'ResourceNotFound'
      ) {
        err = new EmeraldErrorModal({
          message: 'ItemNotFoundInTransaction_Message',
          subMessageArgs: { arg: itemId || '' },
          type: EmeraldDialogTypes.Error,
          subMessage: 'ItemNotFoundInTransaction_SubMessage',
        });
      }
      if (err.code === 'VoidByCodeExceedQuantityLimit') {
        err = new EmeraldErrorModal({
          message: 'VoidedQuantityLargerThanExisting',
          type: EmeraldDialogTypes.Error,
        });
      }
      return err;
    };

    // Define all passed in actions
    const onCancel = (): void => {
      reject(new AbortedError());
    };
    const onKeypadSubmit = (itemId: string): void => {
      cancel(itemId);
    };

    const cancel = (itemId: string, entryMethod?: EntryMethod): void => {
      const quantity = store.getState().salesKeypad.metricValue;
      cancelItemByCode({ itemId, quantity, entryMethod })
        .then(resolve)
        .catch(e => {
          if (e.code === errorCodes.TenderAmountExceededEligibilityAmount) {
            showTenderAmountEligibilityModal(e);
          } else if (e.code === WicTenderRestriction) {
            e.message = 'EwicVoidItem';
            return showEwicErrorModal(e);
          } else {
            popupMessage(formatError(e, itemId));
          }
        });
      // use reject if you want display error and clost the window in the same time
    };

    const onScan = async (scannedData: string): Promise<void> => {
      const itemInputData: IItemInputData = formatScannedData(scannedData);
      return cancelItemByCode(itemInputData)
        .then(resolve)
        .catch(err => {
          popupMessage(formatError(err, scannedData));
        });
      // use reject if you want display error and clost the window in the same time
    };

    //set plu callback
    const pluCallback = async (
      selectedItem?: ISelectedItem,
      itemId?: string,
      entryMethod?: EntryMethod,
    ): Promise<void> => {
      itemId = itemId ?? selectedItem?.selectedItemId ?? '';
      return cancel(itemId, entryMethod);
    };

    setPluCallback(pluCallback);

    // show void by code window
    const voidByCodeProps = { onCancel, onKeypadSubmit };
    showVoidByCodeWindow(voidByCodeProps, onScan);
  })
    .catch(popupMessage) // display any error bubbled up
    .finally(() => {
      // restore home page regardless of the result
      restorePage();
      resetPluCallback();
    });
};
